import styled from 'styled-components';

import colors from 'styles/colors';

export const FormDescriptionStyled = styled.div`
  h3 {
    margin: 0 0 8px;
    font-weight: 600;
    font-size: 18px;
    line-height: 1.5;
    color: #000;
  }

  p,
  li {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: ${colors.gray_scale7};
    white-space: pre-line;
  }
`;
